import script from "./MandiPurchaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MandiPurchaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./MandiPurchaseDetail.vue?vue&type=style&index=0&id=9c6f4dfe&scoped=true&lang=css"
import "./MandiPurchaseDetail.vue?vue&type=style&index=1&id=9c6f4dfe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c6f4dfe"]])

export default __exports__